<template>
  <VCard class="container-popup">
    <VCardTitle>
      <VRow class="pl-4 py-4">
        <h6
          color="textPrimary"
          class="heading-6"
        >
          {{ $t('checkout.bookingExpiredTitle') }}
        </h6>
      </VRow>
    </VCardTitle>
    <VCardText>
      <VRow
        justify="center"
        class="pb-6"
      >
        <img
          :src="require('@slg/web-customer-shared/src/assets/img/booking-expired.svg')"
          :alt="$t('imageAlt.bookingExpired')"
        >
      </VRow>
      <span class="body-1">
        {{ $t('checkout.bookingExpiredText') }}
      </span>
    </VCardText>
    <VCardActions class="px-4 py-4">
      <VBtn
        class="w-100 header__link"
        color="brandingPrimary"
        @click="onClick"
      >
        <span class="button textWhite--text">
          {{ $t('checkout.buttonText') }}
        </span>
      </VBtn>
    </VCardActions>
  </VCard>
</template>
<script lang="ts">
export default {
  name: 'BookingExpiredPopup',
};
</script>

<script setup lang="ts">
import { useRouter } from '../../../composables';

const emit = defineEmits(['trackGtmEventReservationExpired']);
const router = useRouter();

function onClick() {
  emit('trackGtmEventReservationExpired');
  router.push({ name: 'Booking'});
}
</script>
<style lang="scss" scoped>
@import "@slg/web-customer-shared/src/style/headerLinks.scss";

.container-popup {
  width: 430px;
}
</style>
